import React, { FC } from "react";

interface IProps {
  firstName: string;
  lastName: string;
  userType: string;
}

const UserInfo: FC<IProps> = ({ firstName, lastName, userType }) => {
  return (
    <div className="sidenav-user-info">
      <div>
        {firstName} {lastName}
      </div>
      <div>{userType}</div>
    </div>
  );
};

export default UserInfo;
